import { BAR_CHART_LINE_HEIGHTS, CELL_HEIGHTS } from "./settings";

export const getTimelineBarChartHeight = (value) => {
  const i = BAR_CHART_LINE_HEIGHTS.BOUNDARIES.findIndex(b => value <= b);
  let w = 1;
  if(i >= 0) {
    w = BAR_CHART_LINE_HEIGHTS.WEIGHTS[i]
  }
  return CELL_HEIGHTS.XXSMALL * w;
}